import type { ContainerProps } from './container.interface';
import type { FC } from 'react';

import classNames from 'classnames';
import React from 'react';

export const Container: FC<any> = ({ children, className }: ContainerProps) => (
  <div className={classNames('container', className)}>{children}</div>
);
